import { render } from "./DisplayCurrencyPrice.vue?vue&type=template&id=034f20e4"
import script from "./DisplayCurrencyPrice.vue?vue&type=script&lang=js"
export * from "./DisplayCurrencyPrice.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__